export default {
    reset_email_title: "Cambiar correo electrónico",
    reset_email_message: "¿Desea cambiar el correo electrónico?",
    reset_email_success_message: "El correo electrónico ha sido cambiado",
    reset_email_error_message: "No se puede cambiar el correo electrónico debido a un error",
    reset_email_new_email: "Nuevo correo electrónico",
    reset_email_current_email: "Correo electrónico actual",
    reset_email_email_already_registered: "El correo electrónico ya está registrado",
};